import { PreviewCard as PreviewCardPrimitive } from '@base-ui/react/preview-card';
import { cn } from '../../common/functions/cn';
import { useTopLayerPortal } from '../../common/hooks/use-top-layer-portal';

const HoverCard = ({ ...props }: PreviewCardPrimitive.Root.Props) => {
  return <PreviewCardPrimitive.Root data-slot="hover-card" {...props} />;
};

const HoverCardTrigger = ({ ...props }: PreviewCardPrimitive.Trigger.Props) => {
  return <PreviewCardPrimitive.Trigger data-slot="hover-card-trigger" {...props} />;
};

type HoverCardAlign = PreviewCardPrimitive.Positioner.Props['align'];
type HoverCardSide = PreviewCardPrimitive.Positioner.Props['side'];

const HoverCardContent = ({
  className,
  side = 'bottom',
  sideOffset = 4,
  align = 'center',
  alignOffset = 4,
  ...props
}: PreviewCardPrimitive.Popup.Props &
  Pick<PreviewCardPrimitive.Positioner.Props, 'align' | 'alignOffset' | 'side' | 'sideOffset'>) => {
  const { portalAnchor, portalProps, positionerProps } = useTopLayerPortal();
  return (
    <>
      {portalAnchor}
      <PreviewCardPrimitive.Portal data-slot="hover-card-portal" {...portalProps}>
        <PreviewCardPrimitive.Positioner
          {...positionerProps}
          align={align}
          alignOffset={alignOffset}
          side={side}
          sideOffset={sideOffset}
          className="isolate z-50"
        >
          <PreviewCardPrimitive.Popup
            data-slot="hover-card-content"
            className={cn(
              'z-50 w-64 origin-(--transform-origin) rounded-md bg-popover p-2.5 text-popover-foreground text-sm shadow-md outline-hidden ring-1 ring-border duration-100',
              'data-[side=bottom]:slide-in-from-top-2 data-[side=top]:slide-in-from-bottom-2',
              'data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2',
              'data-[side=inline-end]:slide-in-from-left-2 data-[side=inline-start]:slide-in-from-right-2',
              'data-open:fade-in-0 data-open:zoom-in-95 data-open:animate-in',
              'data-closed:fade-out-0 data-closed:zoom-out-95 data-closed:animate-out',
              className
            )}
            {...props}
          />
        </PreviewCardPrimitive.Positioner>
      </PreviewCardPrimitive.Portal>
    </>
  );
};

export { HoverCard, type HoverCardAlign, HoverCardContent, type HoverCardSide, HoverCardTrigger };
